import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { getWhatsappGreeting, DEFAULT_WHATSAPP_GREETING } from "@/lib/admin-settings.functions";
import type { Lang } from "@/content/site";

export const whatsappGreetingQueryOptions = queryOptions({
  queryKey: ["app_settings", "whatsapp_greeting"] as const,
  queryFn: () => getWhatsappGreeting(),
  staleTime: 5 * 60 * 1000,
  gcTime: 30 * 60 * 1000,
});

export function useWhatsappGreeting(lang: Lang): string {
  const { data } = useSuspenseQuery(whatsappGreetingQueryOptions);
  return (lang === "pt" ? data.pt : data.en) || DEFAULT_WHATSAPP_GREETING[lang];
}

export { DEFAULT_WHATSAPP_GREETING };